import {get_check_in_alerts} from '~/api/zero-api';
import useDataLoader from '~/hooks/shared/useDataLoader';


export default function useCheckInAlertLoader() {
    return useDataLoader(get_check_in_alerts);
}
